import { Link } from 'react-router-dom';
import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import DemoBadge from '@/components/feature/DemoBadge';
import Community from '@/pages/home/components/Community';

export default function CommunityPage() {
  return (
    <div className="bg-background-50 text-foreground-950 min-h-screen">
      <Header />
      <main>
        <section className="relative bg-foreground-950 pt-28 md:pt-40 pb-14 md:pb-20 px-4 md:px-8 overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Wide%20view%20of%20diverse%20golfers%20gathered%20together%20on%20a%20sunny%20Southern%20California%20course%2C%20community%20spirit%2C%20deep%20green%20fairways%20with%20dark%20edges%20for%20text%20contrast%2C%20cinematic%20editorial%20photography%2C%20no%20logos&width=1920&height=1080&seq=gs-community-hero&orientation=landscape"
            alt="Golfers gathered on a course"
            title="GreenSide News community"
            className="absolute inset-0 w-full h-full object-cover object-top opacity-40"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-foreground-950 via-foreground-950/70 to-foreground-950/40"></div>
          <div className="relative">
            <div className="flex flex-wrap items-center gap-3">
              <p className="gs-rise font-label uppercase tracking-[0.25em] text-sm text-accent-400 font-bold">Community</p>
              <DemoBadge label="Informational preview" tone="dark" />
            </div>
            <h1 className="gs-rise-2 font-heading font-extrabold uppercase text-background-50 text-5xl md:text-7xl lg:text-8xl leading-[0.9] tracking-tight mt-2 max-w-5xl">
              Golf is better together.
            </h1>
            <p className="gs-rise-3 mt-5 text-background-200 text-base md:text-lg max-w-2xl">
              Adaptive golf, women&apos;s golf, junior development and the community that plays for a cause. This is an overview of the coverage GreenSide News is building.
            </p>
          </div>
        </section>

        <Community />

        <section className="bg-background-100 px-4 md:px-8 py-14 md:py-20">
          <div className="bg-background-50 border border-background-200 border-l-4 border-l-accent-500 rounded-lg p-6 md:p-8 flex flex-col md:flex-row md:items-center justify-between gap-5">
            <div>
              <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">Want to be featured?</h2>
              <p className="mt-2 text-foreground-600 text-sm max-w-xl">Tell us about your program, league or event. Community submissions are a core part of the live platform.</p>
            </div>
            <div className="flex flex-wrap gap-3 shrink-0">
              <Link to="/calendar#list-event" className="bg-primary-500 hover:bg-primary-600 text-background-50 font-label font-bold uppercase tracking-wider text-sm px-5 py-3 rounded-md whitespace-nowrap cursor-pointer transition-colors">List an event</Link>
              <Link to="/partners" className="border border-foreground-950 text-foreground-950 hover:bg-foreground-950 hover:text-background-50 font-label font-bold uppercase tracking-wider text-sm px-5 py-3 rounded-md whitespace-nowrap cursor-pointer transition-colors">Sponsor a beat</Link>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}